import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams } from "react-router";
import { useDispatch } from "../../../app/store";
import { unsubscribeRequest, unsubscribeWeeklyStat } from "../../../app/slices/property";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

export const WebPresentationUnsubscribe = ({ type }) => {
  const urlParams = useParams();
  const { uuid } = urlParams;
  const dispatch = useDispatch();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (type) {
      dispatch(unsubscribeWeeklyStat(uuid));
    } else {
      dispatch(unsubscribeRequest(uuid));
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>LidoHome | Leiratkozás</title>
      </Helmet>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'background.paper',
          display: 'flex',
          minHeight: '100%',
          px: 3,
          py: '80px'
        }}
      >
        <Container maxWidth="lg">
          <Typography
            align="center"
            color="textPrimary"
            variant={mobileDevice ? 'h4' : 'h1'}
          >
            Sikeres leiratkozás
          </Typography>
          <Typography
            align="center"
            color="textSecondary"
            sx={{ mt: 0.5 }}
            variant="subtitle2"
          >
            Az alábbi gombra kattintva visszatérhet a Kezdőlapra.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6
            }}
          >
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6
            }}
          >
            <Button
              color="primary"
              component={RouterLink}
              to="/"
              variant="outlined"
            >
              Kezdőlap
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  )
}
